<template>
    <b-row>
            <b-col md="3" class="pr-2 roleContentLeft">
                <gofix-card class="roleCard mb-0" v-bind:class="{'run-loading': contentLeft.loading}">
                    <div class="roleHeader">
                        <h3>
                            <span class="leftPosition">
                                <b-form-checkbox class="checkboxStyle" v-model="contentLeft.allSelected" @change="selectAllRoles"></b-form-checkbox>
                            </span>
                            Role
                        </h3>
                        <div class="actions">
                            <a class="control-item-link cursor-pointer" v-if="$checkRole($accessModule.roles, 'create')" @click="openRoleModal()" title="Create" v-b-tooltip.hover>
                                <img src="img/blankIcon.png" alt="Create">
                            </a>
                            <a class="control-item-link cursor-pointer" v-if="$checkRole($accessModule.roles, 'delete')" @click="openDeleteRoleModal" title="Delete" v-b-tooltip.hover>
                                <img src="img/deleteIcon.png" alt="Delete">
                            </a>
                            <a class="control-item-link cursor-pointer" v-if="$checkRole($accessModule.roles, 'create') || $checkRole($accessModule.roles, 'update')" @click="openCloneRoleModal" title="Clone" v-b-tooltip.hover>
                                <img src="img/clone.png" alt="Clone">
                            </a>
                        </div>
                    </div>
                    <ul>
                        <li v-for="item in contentLeft.roles" v-bind:class="{active:roleSelected === item.id}">
                            <div class="leftPosition">
                                <b-form-checkbox class="checkboxStyle" :value="item.id" v-model="contentLeft.selected"></b-form-checkbox>
                            </div>
                            <span class="d-block" @click="selectRole(item)">{{item.name}}</span>
                            <div class="rightPosition">
                                <span class="p-0 cursor-pointer" v-if="$checkRole($accessModule.roles, 'update')" @click="openRoleModal(item)">
                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.71 3.63053C18.1 4.02053 18.1 4.65053 17.71 5.04053L15.88 6.87053L12.13 3.12053L13.96 1.29053C14.1468 1.10328 14.4005 0.998047 14.665 0.998047C14.9295 0.998047 15.1832 1.10328 15.37 1.29053L17.71 3.63053ZM0 18.5005V15.4605C0 15.3205 0.05 15.2005 0.15 15.1005L11.06 4.19053L14.81 7.94053L3.89 18.8505C3.8 18.9505 3.67 19.0005 3.54 19.0005H0.5C0.22 19.0005 0 18.7805 0 18.5005Z" fill="#999999"/>
                                    </svg>
                                </span>
                            </div>
                        </li>
                    </ul>
                </gofix-card>
            </b-col>
            <b-col md="9" class="pl-2">
                <gofix-card class="roleCard mb-0" fullContent v-bind:class="{'run-loading': contentRight.loading}">
                    <div class="gofixBasicTable rolePermissionTable" @scroll="infiniteScroll">
                        <div class="dataList roleDataList">
                            <b-table class="animated fadeIn gofixTables" :fields="contentRight.fields" :items="contentRight.permissions" :tbody-tr-class="rowClass" fixed>
                                <template slot="screen" slot-scope="row">
                                    <div class="d-flex justify-content-between screenColumn">
                                        <span>{{row.item.module_name}}</span>
                                        <span class="right">{{row.item.customised_actions ? "(Action)" : "(Module)"}}</span>
                                    </div>
                                </template>

                                <template slot="allow" slot-scope="row">
                                    <b-form-checkbox v-if="row.item.customised_actions"
                                                     :value="1" :unchecked-value="0"
                                                     v-model="row.item.actions[row.item.customised_actions[0].name]"
                                                     :title="row.item.customised_actions[0].name" v-b-tooltip.hover
                                    >

                                    </b-form-checkbox>
                                    <b-form-checkbox v-else disabled :value="1" :unchecked-value="0"></b-form-checkbox>
                                </template>
                                <template slot="create" slot-scope="row">
                                    <b-form-checkbox
                                            v-if="!row.item.customised_actions"
                                            @change="checkReadIsActive(row.item.actions,'create')"
                                            :value="1"
                                            :unchecked-value="0"
                                            title="Create" v-b-tooltip.hover
                                            v-model="row.item.actions.create"></b-form-checkbox>
                                    <b-form-checkbox v-else disabled :value="1" :unchecked-value="0"></b-form-checkbox>
                                </template>
                                <template slot="read" slot-scope="row">
                                    <b-form-checkbox
                                            :disabled="!!row.item.actions.create || !!row.item.actions.update || !!row.item.actions.delete"
                                            v-if="!row.item.customised_actions"
                                            :value="1" :unchecked-value="0"
                                            title="Read" v-b-tooltip.hover
                                            v-model="row.item.actions.read"></b-form-checkbox>
                                    <b-form-checkbox v-else disabled :value="1" :unchecked-value="0"></b-form-checkbox>
                                </template>
                                <template slot="update" slot-scope="row">
                                    <b-form-checkbox
                                            v-if="!row.item.customised_actions"
                                            @change="checkReadIsActive(row.item.actions,'update')"
                                            :value="1"
                                            title="Update" v-b-tooltip.hover
                                            :unchecked-value="0"
                                            v-model="row.item.actions.update"></b-form-checkbox>
                                    <b-form-checkbox v-else disabled :value="1" :unchecked-value="0"></b-form-checkbox>
                                </template>
                                <template slot="delete" slot-scope="row">
                                    <b-form-checkbox
                                            v-if="!row.item.customised_actions"
                                            @change="checkReadIsActive(row.item.actions,'delete')"
                                            :value="1"
                                            title="Delete" v-b-tooltip.hover
                                            :unchecked-value="0"
                                            v-model="row.item.actions.delete"></b-form-checkbox>
                                    <b-form-checkbox v-else disabled :value="1" :unchecked-value="0"></b-form-checkbox>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </gofix-card>
            </b-col>
        <b-modal :no-close-on-backdrop="true" no-close-on-esc id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" @hidden="hiddenModalComfirm" v-model="modals.autocheck.open">
            <div class="center">
                To choose <strong>this option, Read </strong> need to be selected  
                <br><br>
                Do you want to select <strong>Read?</strong>
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="cancelCheck">No</b-button>
                <b-button class="custom-btn" @click="acceptCheck" :disabled="modals.autocheck.loading">
                    <b-spinner v-if="modals.autocheck.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.create.data.id ? 'Edit Role' : 'Create Role'" hide-footer :centered="true" v-model="modals.create.open">
            <div>
                <b-form class="pb-20">
                    <b-row>
                        <b-col sm="12">
                            <gofix-form-input label="Role Name" v-model="modals.create.data.name"></gofix-form-input>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="saveRole" :loading="modals.create.loading" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="modals.delete.open">
            <div class="center">Are you sure you want to delete the selected role(s)?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.delete.open = false">No</b-button>
                <b-button class="custom-btn" @click="deleteRoles" :disabled="modals.delete.loading">
                    <b-spinner v-if="modals.delete.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="modals.clone.open">
            <div class="center mw-250 margin-auto-row">Are you sure you want to clone the selected role(s)?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.clone.open = false">No</b-button>
                <b-button class="custom-btn" @click="cloneRole" :disabled="modals.clone.loading">
                    <b-spinner v-if="modals.clone.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
        </b-row>
</template>
<script>
    export default {
        name: 'Role',
        data() {
            return {
                roleSelected: null,
                roleTypes:[
                    {label: 'FM OFFICER', value: 'FM'},
                    {label: 'CLIENT STAFF', value: 'Client'},
                    {label: 'SUPPLIER', value: 'Supplier'},
                    {label: 'TENANT', value: 'Tenant'}
                ],
                contentLeft:{
                    roles: [],
                    selected: [],
                    allSelected: false,
                    loading:false
                },
                contentRight:{
                    permissions: [],
                    fields:[
                    ],
                    loading:false
                },
                modals:{
                    create: {
                        open:false,
                        loading: false,
                        data: {
                            id: null,
                            name: "",
                            group_tags:"FM",
                            scope:  this.scope
                        }
                    },
                    autocheck:{
                        open:false,
                        loading:false,
                        data:null,
                        key: null
                    },
                    delete:{
                        open:false,
                        loading:false,
                    },
                    clone:{
                        open:false,
                        loading:false,
                    }
                },
                page_role_permissions: 1,
                is_load: true
            }
        },
        props: {
            roleTypeSelector: {
                type: String,
                required: false,
                default: () => "FM"
            },
            scope: {
                type: Number,
                required: false,
                default: () => 1
            },

        },
        watch: {
            "contentLeft.selected": function(val, old) {
                if(this.contentLeft.selected.length > 0 && this.contentLeft.roles.length === this.contentLeft.selected.length) {
                    this.contentLeft.allSelected = true;
                }else{
                    this.contentLeft.allSelected = false;
                }
            },
            roleSelected: function (val,old) {
                if(val){
                    this.is_load = true;
                    this.page_role_permissions = 1;
                    this.contentRight.permissions.length = 0;
                    this.getRolePermissions();
                }
            },
            roleTypeSelector: function (val,old) {
                this.getRoles();
            }
        },
        updated: function () {
            this.$nextTick(function () {
                let gofixCardContent = this.$el.querySelector(".roleCard").clientHeight
                let clientHeightTable = this.$el.querySelector(".b-table").clientHeight;
                if(clientHeightTable <= gofixCardContent && !this.contentRight.loading && this.roleSelected && this.is_load) {
                    this.page_role_permissions += 1;
                    this.getRolePermissions();
                }
            })
        },
        created() {
            this.getRoles();
            // get default setting
            this.$store.dispatch('AuthController/getNewColumnSettingsTableUser', {
                user_id: 0,
                table_name: "account-roles"
            }).then(response => {
                var columnSettings = response.data.data;
                var tmpShow =  columnSettings.settings.fields.filter(item => item.isActive == 1).sort((a,b) => a.sequence > b.sequence)

                tmpShow.forEach((obj) => {
                    // set filter
                    if(obj.filter.active){
                        obj.isFilter = true
                    }else{
                        obj.isFilter = false
                    }
                })
                this.contentRight.fields = tmpShow;
                // add class add fields action
                this.contentRight.fields.forEach((item) => {
                    if (item.key === 'screen') {
                        item.tdClass = 'border-right';
                        item.thClass = 'border-right';
                    }
                })
            })
        },
        methods: {
            rowClass(item, type) {
                if(item.module_name == "Budget") return "d-none";
                return;
            },
            infiniteScroll() {
                let gofixCardContent = this.$el.querySelector(".roleCard").clientHeight
                let scrollTop = this.$el.querySelector(".rolePermissionTable").scrollTop;
                let scrollHeight = this.$el.querySelector(".rolePermissionTable").scrollHeight;
                if((scrollTop + gofixCardContent) >= scrollHeight && this.is_load) {
                    this.page_role_permissions += 1;
                    this.getRolePermissions();
                }
            },
            getRoles(){
                this.contentLeft.loading = true;
                this.$store.dispatch("RoleController/getRoleItems",{
                    filter : {
                        group_tags : this.roleTypeSelector,
                        scope: this.scope
                    }
                })
                    .then(response => {
                        this.contentLeft.roles = response.items;
                        this.roleSelected = this.contentLeft.roles[0].id;
                        this.contentLeft.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.contentLeft.loading = false;
                    });
            },
            selectRole(item){
                if(item.id !== this.roleSelected){
                    this.roleSelected = item.id;
                }
            },
            selectAllRoles(val){
                if (val) {
                    this.contentLeft.selected = [];
                    for (let i in this.contentLeft.roles) {
                        this.contentLeft.selected.push(this.contentLeft.roles[i].id)
                    }
                }
                else {
                    this.contentLeft.selected = [];
                }
            },
            openRoleModal(item){
                if(item){
                    this.modals.create.data.id = item.id;
                    this.modals.create.data.name = item.name;
                    this.modals.create.data.group_tags = item.group_tags;
                    this.modals.create.data.scope = item.scope;
                }else{
                    this.modals.create.data.id = null;
                    this.modals.create.data.name = null;
                    this.modals.create.data.group_tags = this.roleTypeSelector;
                    this.modals.create.data.scope = this.scope;
                }
                this.modals.create.open = true;
            },
            saveRole(){
                if(!this.modals.create.data.name){
                    return this.$alertNotification("Please enter Name field", "primary");
                }
                if(this.modals.create.data.name.length > 31){
                    return this.$alertNotification("Role name cannot exceed 31 characters", "danger");
                }
                if(this.modals.create.loading) return ;
                this.modals.create.loading = true;
                let action = "createRoleItem";
                let keyMessage = 'adding';
                if(this.modals.create.data.id) {
                    keyMessage = 'editing';
                    action = "updateRoleItem";
                }
                this.$store.dispatch(`RoleController/${action}`,this.modals.create.data)
                    .then(data => {
                        this.getRoles();
                        this.modals.create.open = false;
                        this.modals.create.loading = false;
                        this.$alertNotification(this.$notificationV2(keyMessage, 'roles_authorisation'));
                    })
                    .catch(error =>{
                        this.modals.create.loading = false;
                        if(error.response.data.error && error.response.data.error.message.error){
                            return this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                    });
            },
            openDeleteRoleModal(){
                if(this.contentLeft.selected.length){
                    this.modals.delete.open = true;
                }else{
                    return this.$alertNotification("Please select a role to delete", "danger");
                }
            },
            deleteRoles(){
                if(this.contentLeft.selected.length){
                    this.$store.dispatch("RoleController/deleteRoleItem", this.contentLeft.selected)
                        .then(data => {
                            this.contentLeft.selected = [];
                            this.modals.delete.open = false;
                            this.modals.delete.loading = false;
                            this.getRoles();
                            this.$alertNotification(this.$notificationV2('deleting', 'roles_authorisation'));
                        })
                        .catch(err => {
                            console.log(err);
                            this.modals.delete.loading = false;
                        });
                }else{
                    this.modals.delete.open = false;
                    return this.$alertNotification("Please select a role to delete", "danger");
                }
            },
            openCloneRoleModal(){
                if(this.contentLeft.selected.length){
                    this.modals.clone.open = true;
                }else{
                    return this.$alertNotification("Please select a role to clone", "danger");
                }
            },
            cloneRole(){
                if(this.contentLeft.selected.length){
                    this.$store.dispatch("RoleController/cloneItem", this.contentLeft.selected)
                        .then(data => {
                            this.modals.clone.open = false;
                            this.modals.clone.loading = false;
                            this.getRoles();
                        })
                        .catch(err => {
                            console.log(err);
                            this.modals.clone.loading = false;
                        });
                }else{
                    this.modals.clone.open = false;
                }
            },
            getRolePermissions(){
                this.contentRight.loading = true;
                this.$store.dispatch("RoleController/getRolePermissions",{
                    page: this.page_role_permissions,
                    limit: 100,
                    filter : {
                        role_id : this.roleSelected,
                    }
                })
                    .then(response => {
                        if(response.items.length) {
                            let arr = response.items.map(el => {
                                if(el.customised_actions){
                                    el.customised_actions = JSON.parse(el.customised_actions);
                                }
                                return el;
                            });
                            this.contentRight.permissions = this.contentRight.permissions.concat(arr);
                        } else {
                            this.is_load = false
                        }
                        // this.contentRight.permissions = response.items.map(el => {
                        //     if(el.customised_actions){
                        //         el.customised_actions = JSON.parse(el.customised_actions);
                        //     }
                        //     return el;
                        // });
                        this.contentRight.loading = false;
                    })
                    .catch(error => {
                        console.log(error)
                        this.contentRight.loading = false;
                    });
            },
            checkReadIsActive(item,key){
                if(!item[key] && !item.read && key !== "read"){
                    this.modals.autocheck.open = true;
                    this.modals.autocheck.data = item;
                    this.modals.autocheck.key = key;
                }
            },
            acceptCheck(){
                this.modals.autocheck.data[this.modals.autocheck.key] = 1;
                this.modals.autocheck.data.read = 1;
                this.modals.autocheck.open = false;
            },
            cancelCheck(){
                this.modals.autocheck.data[this.modals.autocheck.key] = 0;
                this.modals.autocheck.data.read = 0;
                this.modals.autocheck.open = false;
            },
            hiddenModalComfirm(){
                this.modals.autocheck = {
                    open:false,
                    loading:false,
                    data:null,
                    key: null
                };
            },
            savePermissions(){
                if(this.contentRight.loading) return;
                this.contentRight.loading = true;
                this.$store.dispatch("RoleController/updateRolePermission",{
                    items: this.contentRight.permissions,
                    filter: {
                        role_id : this.roleSelected,
                    }
                })
                    .then(data => {
                        this.contentRight.loading = false;
                    })
                    .catch(err => {
                        this.contentRight.loading = false;
                    });
            }
        }
    }
</script>
